import { configureScope } from "@sentry/core";
import { useEffect } from "react";

export function useSentryTag(tagName, tagValue) {
  useEffect(() => {
    configureScope((scope) => scope.setTag(tagName, tagValue));
  }, [tagName, tagValue]);
}
